<ol *ngIf="(breadcrumbs$ | async)?.length > 1" id="breadcrumbNav" class="breadcrumb-nav">
    <li *ngFor="let breadcrumb of breadcrumbs$ | async; let i = index">
        <button class="goto" *ngIf="i !== (breadcrumbs$ | async)?.length - 1"
            (click)="handleRouteChange(breadcrumb.url)">{{
            breadcrumb.label }}</button>
        <span class="breadcrumb-last-li" *ngIf="i === (breadcrumbs$ | async)?.length - 1">{{ breadcrumb.label }}</span>
    </li>
</ol>
<br>